<template>
    <div>
      <p class="ArticleNormal">
        以短视频为媒，众多传统旅游城市焕发出了更时尚、更生活、更亲切的形象，尤其是头部达人创作的爆款内容，往往能在一夜之间获赞百万，将城市直接带上热搜、变身新晋“网红打卡地”。
      </p>
      <p class="ArticleNormal">
        以深圳为例——如果仅以“钢筋水泥的森林、繁荣现代的都市”等文字来形容它，很难触动人们的心灵。但在@小小莎老师 的短视频里，早高峰的地铁站、凌晨一点的科兴科技园、和她在深圳创业的经历相融合，这座“造梦之城”的魅力便生动呈现了出来，激起了广泛的群体共鸣。
      </p>
      <video src="../../../assets/1st/Articles/Article_10/video_1.mp4" controls poster="../../../assets/1st/Articles/Article_10/poster_1.jpg"></video>
      <p class="ArticleNormal">
        阿勒泰拥有着与深圳截然不同的风貌，但人们也很难准确说出它与新疆其他城市的区别。而在@秦鹏P的话 的镜头下，这座城市的“面容”清晰了起来——世界级秋色、神的后花园、饕餮美食，在无数用户心中种下了一片草原。
      </p>
      <p class="ArticleNormal">
        创作者们的风格、调性各不相同，成都、重庆、西安等“网红城市”的景色和文化也各异，是否存在一条关于城市短视频营销的最佳走红路径？在打造城市名片过程中，又有哪些“爆款生成法则”？通过与五位抖音头部创作者对话，我们提炼出了四大黄金方法论。
      </p>
      <p class="ArticleHead">
        法则一：立足城市本位，遴选“同道达人
      </p>
      <p class="ArticleNormal">
        自然景区、文化古镇、现代都市……景致不同，要通过镜头表达出的主题和内容自然也有差异。
      </p>
      <p class="ArticleNormal">
        这就对创作者提出了一定要求：水秀山清、岁月静好型的达人，可能无法完美呈现大都市的独特之处；而走实用攻略路线的创作者，也很难拍出山水田园的文艺清新范儿。
      </p>
      <p class="ArticleNormal">
        比如，@房琪kiki 就坦言：“如果让我来讲述都市的繁华，我并不觉得自己在表达和文案上有任何优势。”文艺、精致才是她的特色，也是她最擅长的风格。以一句“山是眉峰聚，水是眼波横”和一首古风歌曲《杀破狼》，@房琪kiki 将贵州省荔波县的自然风光展现得超凡脱俗。到了凤冈县，她又用《诗经》中的“凤凰鸣矣，于彼高冈”来形容古寨是“藏在了尘世间”，溪流、田野、水车和劳作的阿婆在她的镜头下共同组成了桃花源般的绝美景致。
      </p>
      <video src="../../../assets/1st/Articles/Article_10/video_2.mp4" controls poster="../../../assets/1st/Articles/Article_10/poster_2.jpg"></video>
      <p class="ArticleNormal">
        在她看来，创作者各有所长，城市需要在明确自身特色、定位及主题后，选择调性契合的达人，才能最大化激发他们的创作灵感，将城市特色进一步放大。
      </p>
      <p class="ArticleNormal">
        此外，相较于直接拍摄独特美食、热闹景区的视频，美好的景象和文字带给用户的可能是更加“细水长流”的感受——不仅能在平台上传播，也可以授权城市长期投放于线下，形成长尾效应——但很难带动短期的冲动性消费，也无法满足部分以一夜爆红、快速转化为目的的城市的需求。
      </p>
      <p class="ArticleNormal">
        因此，对城市而言，营销目标的明确也非常关键——是长期的品牌构建还是短期的引流转化，不同目标所需的内容风格、类型不同，可选择的博主也不同。
      </p>
      <p class="ArticleHead">
        法则二：打造达人矩阵，呈现“一城千面”
      </p>
      <p class="ArticleNormal">
        每个达人都从自己的视角输出一种风格和人设，而一千个人眼中有一千个哈姆雷特——如果让多层次的创作者多角度解读和创作，城市形象传播便有了“一城千面”的可能。
      </p>
      <p class="ArticleNormal">
        @秦鹏P的话 的爆款短视频“北疆旅行线路宝藏攻略”就是这样的矩阵共创作品之一。在外界的普遍印象中，新疆旅游的最佳时间是夏秋两季，寒冷且漫长的冬季属于淡季，为了挖掘阿勒泰的冬季旅游潜力，包括秦鹏在内的多位攻略向、情感向、剧情向达人受邀一起去到当地进行体验创作，最终产出了一大批优质内容，在站内集中释放形成了较大声量，为当地带去了极好的收益。
      </p>
      <video src="../../../assets/1st/Articles/Article_10/video_3.mp4" controls poster="../../../assets/1st/Articles/Article_10/poster_3.jpg"></video>
      <p class="ArticleNormal">
        这首先满足了用户的多元需求。“计划去玩的人肯定要看攻略，会去搜一些实用信息，另外他也想看那种情感和风景统一状态的内容，就会去找到情感旅行类的视频。“
      </p>
      <p class="ArticleNormal">
        同时也成就了城市营销的高光时刻——短时间内，不同创作者在多个角度共同展现城市的不同横截面，声量更集中，曝光效应更强，城市的形象也更立体了。“理性来看，在站内发10条短视频和发1000条短视频，肯定是后者更有优势。”秦鹏说道。
      </p>
      <p class="ArticleNormal">
        而@房琪kiki 和@小小莎老师 也表达了同样的观点。前者认为“通过一己之力带动数据并不现实”，城市必定是要以多类型创作者组合的形式来完成传播。而在后者看来，抖音平台原本的传播逻辑就是从头部、腰部KOL到更多KOC的层层联动，让不同等级、风格的创作者吸引流量，进而带动普通用户参与，以“全民创作”之势让城市快速累积内容，形成并扩大影响力。
      </p>
      <p class="ArticleNormal">
        另外需要关注的是，城市在整个营销活动中并非“置身事外”即可。据@秦鹏P的话 介绍，在阿勒泰活动中，创作者其实是和城市宣传方、平台共同进行了一次“共创”——三方共同参与前期策划、内容设计和创作以及最终的营销安排等环节，从各自不同视角给出有益的想法和建议，并在彼此思想碰撞和想法交流后形成了更具针对性、落地性更高的方案，让城市内容的裂变更完整，最终才得以取得极好的效果。
      </p>
      <p class="ArticleHead">
        法则三：深挖独家底蕴，点亮城市名片
      </p>
      <p class="ArticleNormal">
        如果跳出营销整体策略，将视线聚焦于单个爆款短视频的打造，关键依然在于内容本身。
      </p>
      <p class="ArticleNormal">
        优质是内容火爆的先决条件。在抖音的分发机制下，一条短视频只有在经过第一次推荐得到较好用户反馈后才能够进一步扩大范围，覆盖更多用户，而如果内容品质不达标，就无法获得更多轮次的推荐。
      </p>
      <p class="ArticleNormal">
        因此，城市传播首先会选择与头部创作者合作。他们有一定量专业知识和人生经历的积累，能够保证内容品质。例如@兵马俑冰蛋 的家人都从事博物馆相关工作，他自己也已经当了八年导游，说起历史来如数家珍。
      </p>
      <video src="../../../assets/1st/Articles/Article_10/video_4.mp4" controls poster="../../../assets/1st/Articles/Article_10/poster_4.jpg"></video>
      <p class="ArticleNormal">
        其次，这些人的创作经验也足够丰富。他们在前期会留出时间做设计、策划和拍摄准备；同时十分明确自己擅长的风格和内容形式，对平台、用户以及短视频调性更加了解，能够有效降低失误率。
      </p>
      <p class="ArticleNormal">
        在保证内容品质的基础上，深挖城市亮点、探寻城市的独特文化底蕴成为打造爆款的关键。
      </p>
      <p class="ArticleNormal">
        例如@兵马俑冰蛋 就是以幽默诙谐的语言和陕西方言讲解陕西的文物古迹，带动了景区和整个城市对用户的吸引力。
      </p>
      <p class="ArticleNormal">
        “西安这个地方，以及整个陕西省境内，所有的人文景观都是历史类的。怎样把历史内容讲得明明白白，让大家喜欢听，进而爱上西安，是我的出发点。”在@兵马俑冰蛋 看来，每个城市都有自己的特点和文化底蕴，达人的作用就是将这些特点讲得好听、拍得好看，并聚焦于一个元素不断放大，将其打造为一张城市名片。
      </p>
      <p class="ArticleNormal">
        而这并不意味着内容的同质化。在平台新人辈出、竞争激烈，并且已有很多相似元素被拿来创作的环境下，创作者为了跟上平台发展和用户需求变化，必须探索新内容、新风格，而这也是城市宣传需关注的重点。
      </p>
      <p class="ArticleNormal">
        创作者@幻想家japaul 就认为“是竞争一直在逼着自己进步”。发现最初的纯美景内容吸引力不强后，他就增加了拍摄经验分享、情感故事等，后来科幻、悬疑、探秘等内容开始流行，他又在城市旅行短视频中加入密室逃脱、神话故事、悬疑探秘等元素，使其变身系列化“微综艺”，例如与洛阳市栾川县相关的《河神传说》，在郑州市拍摄的系列化内容《兔人传说》、《富江》等。
      </p>
      <video src="../../../assets/1st/Articles/Article_10/video_5.mp4" controls poster="../../../assets/1st/Articles/Article_10/poster_5.jpg"></video>
      <p class="ArticleNormal">
        “我做旅游博主八年，看过很多人一夜之间火了，第二天又凉了，一点都不夸张。”他表示，太多达人“昙花一现”都是因为规行矩步，不能紧跟变化、掌握用户内容偏好，“一定要着眼于未来。
      </p>
      <p class="ArticleHead">
        法则四：结合平台“地利”，达成消费转化
      </p>
      <p class="ArticleNormal">
        在掌握用户喜好和习惯这件事上，平台也在努力跟进。
      </p>
      <p class="ArticleNormal">
        例如现阶段，达人在创作城市内容时已习惯于加上POI功能，用户点击视频中的定位图标，就能够跳转至与该城市、景区或店铺相关内容的集合页面，并附地址、营业时间等信息。“这就省去了很多麻烦——点进去之后，既有详细地址，又有现场照片，还有大家发布的视频，一开始没多大兴趣的人看了可能也会瞬间种草。”@幻想家japaul 说到。
      </p>
      <p class="ArticleNormal">
        POI成为了线上兴趣内容与线下城市、景区、门店之间的“时空传送门”，大大缩短了用户从被“种草”到线下消费的转化路径。即便是较难快速转化的旅行内容，通过POI中的“想去”这一收藏功能，也可以加深用户印象，成为他计划旅行时的首选地点。
      </p>
      <p class="ArticleNormal">
        其次，用户还能够在这个页面刷到无数由不同等级创作者以多角度创作的内容以及普通用户线下打卡的真实体验记录。它们叠加出现形成了POI话题流量池，可以实现整个城市或景区、门店的高曝光和高转化。
      </p>
      <p class="ArticleNormal">
        当然，在每天都在使用POI功能的创作者看来，城市品牌营销路径还可以通过功能的优化升级实现进一步提升。@兵马俑冰蛋 期望这个功能可以直接带上景区门票、纪念品、衍生产品等商品：“导游都面临一个直观问题，虽然通过抖音宣传了自己，但实际对接的时候还是会有一定难度。”POI加上更多电商功能后，形成了从线上内容到线下消费的完整转化链条，会创造更大的流量转化空间，为导游、景区甚至是整个城市带来更直观的收益。
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">结语</span>
      </p>
      <p class="ArticleNormal">
        用短视频带火一座城并非偶然，在内容发布前，创作者已对平台调性、用户喜好以及自己的擅长风格了然于心，并做好了充足的前期准备。
      </p>
      <p class="ArticleNormal">
        同时，这件事也并非只依靠单一创作者，是城市宣推方、平台与创作者一起“共创内容”。从前期明确营销目标、深挖城市特色找寻亮点，到内容的创作和传播，城市品牌的构建和形象的塑造，始终是由三方合力成就，在这一过程中，城市本身就是深度的参与者。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article10"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
  video{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article10.vue